<template>
  <li class="nav-item">
    <a
      href="#"
      class="nav-link"
      :class="[directionClass, activeClass, disableClass]"
      @click.prevent="selectTab"
    >
      <slot></slot>
    </a>
  </li>
</template>

<script>
export default {
  name: 'TabHorizontal',
  inject: ['elProp'],
  props: {

    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    activeClass () {
      return {
        active: this.isActive
      }
    },
    disableClass () {
      return {
        tab__disabled: this.disabled
      }
    },
    directionClass () {
      return {
        tab__vertical: this.elProp.vertical
      }
    }
  },
  methods: {
    selectTab () {
      if (this.disabled) return

      let th = this

      this.isActive = true
      this.$set(this.elProp, 'activeTab', this)
      this.$emit('click')

    }
  }
}
</script>
